






































































import Vue from 'vue';

import api from '@/common/api';
import PageLoader from '@/common/components/PageLoader.vue';
import { mapGetters } from 'vuex';
import HppFieldRow from '@/merchant/views/hosted-payments/design-components/HppRow.vue';
import { Feature } from '@/features.types';
import { JsonApiSingleResponse } from '@/jsonApi.types';
import { reformatCustomFields, initPaymentMethod } from '@/common/util/payments.util';
import { initCustomer } from '@/common/util/customers.util';
import { Transaction, TransactionStatus } from '@/common/types/transactions.types';
import {
  initVirtualTerminalTransaction,
  initCustomFields,
  VirtualTerminalTransaction,
} from '@/common/types/virtualTerminal.types';
import {
  fillCustomerInHPP,
  fillPaymentMethodInHPP,
  fillTransactionWithCustomer,
  fillTransactionWithPaymentMethod,
  fillCustomFieldsInHpp,
  fillTransactionWithPaymentInfoFields,
} from '@/common/util/virtualTerminal.util';
import PaymentDetailsModal from '@/common/components/payments/PaymentDetailsModal.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import axios from 'axios';
import {
  HppColumn,
  HppRow,
  toggleShippingInformation,
  HppFieldAttribute,
} from '@/common/util/hostedPaymentPages.util';
import { Subscription } from '@/common/types/subscriptions.types';
import { AlertType } from '@/common/components/alerts.types';
import Alert from '@/common/components/Alert.vue';
import {
  CustomFieldFillable,
  DefaultLevel3Setting,
  initDefaultLevel3Setting,
} from '@/common/components/support/support.types';
import getDomain from '@/common/domain';
import { PaymentPage } from './paymentPages.types';
import { isActive } from './paymentPages.util';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
    isPreview: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      AlertType,
      Feature,
      TransactionStatus,
      config: {
        loadingText: 'Processing...' as string,
        customer: initCustomer(),
        customFields: initCustomFields(),
        isSubmitting: false,
        paymentMethod: initPaymentMethod(),
        transaction: initVirtualTerminalTransaction(),
        enhancedFields: [] as Array<CustomFieldFillable>,
        defaultLevel3Setting: initDefaultLevel3Setting() as DefaultLevel3Setting,
      },
      content: '' as string,
      paymentPage: null as PaymentPage | null,
      hppConfig: [] as HppRow[],
      txnResponse: null as JsonApiSingleResponse<any> | null,
      subscription: null as Subscription | null,
      reCaptcha: false as boolean,
      showNotActivePage: false as boolean,
      showAlert: true as boolean,
      showShippingFields: false as boolean,
    };
  },
  created() {
    document.title = (this as any).brandName;
  },
  mounted() {
    this.loadPaymentPageInfo();
  },
  methods: {
    loadPaymentPageInfo() {
      api
        .get(`/payment-pages/${this.id}`, this.skipAuthConfig)
        .then(({ data: { data } }) => {
          this.paymentPage = data;
          if (data.name) {
            document.title = data.name;
          }
          this.hppConfig = JSON.parse(data.jsonData);
          const cols = this.hppConfig[0].columns;
          Object.keys(cols).forEach((key: any) => {
            const colArr = cols[key];
            if (colArr.name === 'additionalFields') {
              if (colArr.fields.length === 1) {
                this.hppConfig[0].columns[key].fields.splice(0, 1);
              }
            }
            if (colArr.name === 'shippingAddress') {
              Object.keys(colArr.fields).forEach((fieldKey: any) => {
                if (colArr.fields[fieldKey].name === 'shippingEnabled') {
                  const shippingBtnLabel = (colArr.fields[fieldKey].attributes as HppFieldAttribute).label;
                  if (shippingBtnLabel === 'Hide shipping information') {
                    this.showShippingFields = true;
                  }
                }
              });
            }
          });
          this.loadPaymentPageContent();
        })
        .catch(() => {
          (this as any).$toasted.error('Problem loading payment page');
          if ((this as any).$refs.loader) {
            ((this as any).$refs.loader as any).setError();
          }
        });
    },
    loadPaymentPageContent() {
      if (this.isHppActive || this.isPreview) {
        this.showNotActivePage = false;
        ((this as any).$refs.loader as any).setReady();
      } else {
        this.showNotActivePage = true;
      }
    },
    submitTransaction() {
      if (!this.isValid || !this.reCaptcha) {
        return;
      }
      this.txnResponse = null;
      this.submitActions(true);

      let txn: VirtualTerminalTransaction;

      const hostedPaymentPageId = this.paymentPage?.id;

      const hppColumns = this.hppConfig.reduce(
        (columns: HppColumn[], row: HppRow) => columns.concat(row.columns),
        [],
      );
      const customerBillingData = hppColumns.find((columns) => columns.name === 'billingAddress');
      const customerShippingData = hppColumns.find((columns) => columns.name === 'shippingAddress');
      if (customerBillingData && customerShippingData) {
        const customer = fillCustomerInHPP(
          customerBillingData,
          customerShippingData,
          this.config.customer,
        );
        txn = fillTransactionWithCustomer(this.config.transaction, customer);
      }

      const paymentMethodData = hppColumns.find((columns) => columns.name === 'paymentMethod');
      const paymentMethod = fillPaymentMethodInHPP(paymentMethodData, this.config.paymentMethod);

      const customFieldsData = hppColumns.find(
        (columns: any) => columns.name === 'additionalFields',
      );
      if (customFieldsData) {
        const customFields = fillCustomFieldsInHpp(customFieldsData);
        txn!.customFields = reformatCustomFields(customFields);
      }

      txn = fillTransactionWithPaymentMethod(
        txn!,
        paymentMethod,
        paymentMethod.type,
        hostedPaymentPageId,
      );

      const paymentFieldsData = hppColumns.find((columns) => columns.name === 'paymentFields');
      if (paymentFieldsData) {
        txn = fillTransactionWithPaymentInfoFields(txn!, paymentFieldsData);
      }

      txn.amount = this.paymentPage?.isFixedAmount
        ? this.paymentPage.amount
        : (paymentMethodData as any).fields[0].attributes.values.amount;


      // if payment method was keybank and has keybank processor, automatically set industry to web
      if (this.hasKeybankProcessor && paymentMethod.keybank?.industry) {
        txn.transactionType = 'web';
      }

      if (!this.paymentPage?.isRecurring) {
        axios
          .post(`${getDomain('api')}/transactions`, txn, {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${this.paymentPage!.token}`,
            },
          })
          .then(({ data }: { data: JsonApiSingleResponse<Transaction> }) => {
            this.submitActions(false);
            this.txnResponse = data;
            (this.$refs.paymentDetailsModal as any).setVisibility(true);
            this.$toasted.success('Transaction processed!');
          })
          .catch((this as any).handleTransactionError);
      } else {
        const subscription = {
          name: this.paymentPage?.plan?.name,
          description: this.paymentPage?.plan?.description,
          amount: this.paymentPage?.plan?.amount,
          paymentMethod: txn.paymentMethod,
          customer: txn.customer,
          customFields: txn!.customFields,
          industry: paymentMethod.ach?.industry,
        };
        axios.post(`${getDomain('api')}/subscriptions`, subscription, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${this.paymentPage!.token}`,
          },
        }).then(({ data }: { data: JsonApiSingleResponse<Subscription> }) => {
          this.submitActions(false);
          this.txnResponse = { data: data.data?.transaction };
          this.subscription = data?.data!;
          (this.$refs.paymentDetailsModal as any).setVisibility(true);
          this.$toasted.success('Transaction processed!');
        }).catch((this as any).handleSubscriptionError);
      }
    },
    submitActions(
      isSubmitting: boolean,
      loadingText: string = 'Processing...',
      resetForms: boolean = false,
    ) {
      this.config.isSubmitting = isSubmitting;
      this.config.loadingText = loadingText;
      if (!isSubmitting && resetForms) {
        (this as any).resetForms();
      }
    },
    resetResponse() {
      if (this.txnResponse?.data.status === TransactionStatus.CAPTURED) {
        this.redirect();
      }
      this.txnResponse = null;
    },
    toggleShipping(fieldLabel: string) {
      this.hppConfig = this.hppConfig.map(toggleShippingInformation);
      this.showShippingFields = fieldLabel === 'Use different shipping information';
    },
    handleTransactionError({ response }: any) {
      this.submitActions(false);
      this.txnResponse = response;
      (this.$refs.paymentDetailsModal as any).setVisibility(true);
    },
    handleSubscriptionError({ response }: any) {
      this.submitActions(false);
      this.txnResponse = response;
      (this.$refs.paymentDetailsModal as any).setVisibility(true);
    },
    redirect() {
      if (this.paymentPage!.redirect) {
        if (
          this.paymentPage!.redirect!.includes('https://')
          || this.paymentPage!.redirect!.includes('http://')
        ) {
          window.location.replace(this.paymentPage!.redirect);
        } else {
          window.location.replace(`https://${this.paymentPage!.redirect}`);
        }
      } else {
        this.$router.go(0);
      }
    },
    robotCheck(robot: boolean) {
      this.reCaptcha = robot;
    },
  },
  computed: {
    ...mapGetters(['brandName', 'isEnhancedDataEnabled']),
    skipAuthConfig(): any {
      return { skipAuthentication: true };
    },
    isHppActive(): boolean {
      return isActive(this.paymentPage);
    },
    isValid(): boolean {
      return ((this as any).$refs.form as any).validate();
    },
    hasCreditCardProcessor(): boolean {
      return this.paymentPage!.hasCreditCardProcessor;
    },
    hasAchProcessor(): boolean {
      return this.paymentPage!.hasAchProcessor;
    },
    hasKeybankProcessor(): boolean {
      return this.paymentPage!.hasKeybankProcessor;
    },
    alertMessage() {
      return 'This Payment Page is not active yet.';
    },
  },
  components: {
    PageLoader,
    HppFieldRow,
    PaymentDetailsModal,
    LoadingModal,
    Alert,
  },
});
